import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import PropertyListingLayout from '@/views/Layout/PropertyListingLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
import BlankLayout from '@/views/Layout/BlankLayout.vue';

// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';
import SubscriptionEnded from '@/views/GeneralViews/SubscriptionEnded.vue';
import InvalidAccount from '@/views/GeneralViews/InvalidAccount.vue';

// Calendar
const Calendar = () => import(/* webpackChunkName: "extra" */ '@/views/Calendar/Calendar.vue');
const CustomersCalendar = () => import(/* webpackChunkName: "extra" */ '@/views/Calendar/CustomersCalendar.vue');
const CasesCalendar = () => import(/* webpackChunkName: "extra" */ '@/views/Calendar/CasesCalendar.vue');

// Charts
const Charts = () => import(/* webpackChunkName: "dashboard" */ '@/views/Charts.vue');

// Components pages
const Buttons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Buttons.vue');
const Cards = () => import(/* webpackChunkName: "components" */ '@/views/Components/Cards.vue');
const GridSystem = () => import(/* webpackChunkName: "components" */ '@/views/Components/GridSystem.vue');
const Notifications = () => import(/* webpackChunkName: "components" */ '@/views/Components/Notifications.vue');
const Icons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Icons.vue');
const Typography = () => import(/* webpackChunkName: "components" */ '@/views/Components/Typography.vue');
const NestedSorting = () => import(/* webpackChunkName: "components" */ '@/views/Components/NestedSorting.vue');

// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');
const AlternativeDashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/AlternativeDashboard.vue');
const Widgets = () => import(/* webpackChunkName: "dashboard" */ '@/views/Widgets.vue');

// Forms pages
const FormElements = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormElements.vue');
const FormComponents = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormComponents.vue');
const FormValidation = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormValidation.vue');

// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/GoogleMaps.vue');
const VectorMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/VectorMaps.vue');

// Pages
const User = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserProfile.vue');
const Pricing = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Pricing.vue');
const TimeLine = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/TimeLinePage.vue');
const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const Home = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Home.vue');
const Register = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Register.vue');
const Lock = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Lock.vue');

//single page
const Messaging = () => import(/* webpackChunkName: "pages" */ '@/views/Messaging/MessagingPage.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/RegularTables.vue');
const SortableTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/SortableTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/PaginatedTables.vue');

// Setup pages
const Users = () => import(/* webpackChunkName: "tables" */ '@/views/Setup/UsersFolder/Users.vue');
const AddUsers = () => import(/* webpackChunkName: "tables" */ '@/views/Setup/UsersFolder/AddUsers.vue');
const EditUsers = () => import(/* webpackChunkName: "tables" */ '@/views/Setup/UsersFolder/EditUsers.vue');
const MyUserProfile = () => import(/* webpackChunkName: "tables" */ '@/views/Setup/UsersFolder/UserProfile/MyUserProfile.vue');

const VariableExpense = () => import(/* webpackChunkName: "tables" */ '@/views/Setup/VariableExpenseFolder/VariableExpense.vue');
const AddVariableExpense = () => import(/* webpackChunkName: "tables" */ '@/views/Setup/VariableExpenseFolder/AddVariableExpense.vue');
const EditVariableExpense = () => import(/* webpackChunkName: "tables" */ '@/views/Setup/VariableExpenseFolder/EditVariableExpense.vue');

// Financial Proposal pages
const FinancialProposal = () => import(/* webpackChunkName: "tables" */ '@/views/FinancialProposal/FinancialProposal.vue');
const FinancialProposalDemo = () => import(/* webpackChunkName: "tables" */ '@/views/FinancialProposal/demo/FinancialProposalDemo.vue');
const CustomerFinancialProposal = () => import(/* webpackChunkName: "tables" */ '@/views/FinancialProposal/CustomerFinancialProposalFolder/CustomerFinancialProposal.vue');

// Customer Profile pages
const CustomerProfile = () => import(/* webpackChunkName: "tables" */ '@/views/CustomerProfile/CustomerProfileListings/CustomerProfile.vue');
const CustomerProfileDetails = () => import(/* webpackChunkName: "tables" */ '@/views/CustomerProfile/CustomerProfileDetails/CustomerProfileDetails.vue');

// Hub Listings
const HubListings = () => import(/* webpackChunkName: "tables" */ '@/views/Hub/HubListings.vue');
const EditHubDetails = () => import(/* webpackChunkName: "tables" */ '@/views/Hub/HubDetails/EditHubDetails.vue');

// Hub Profile
const HubProfile = () => import(/* webpackChunkName: "tables" */ '@/views/Commission/Hub/HubProfile.vue');
const HubProfileDetails = () => import(/* webpackChunkName: "tables" */ '@/views/Commission/Hub/HubProfile/HubProfileDetails.vue');
const TeamProfileDetails = () => import(/* webpackChunkName: "tables" */ '@/views/Commission/Hub/HubProfile/TeamProfileDetails.vue');
const HubPendingApproval = () => import(/* webpackChunkName: "tables" */ '@/views/Commission/HubApproval/HubPendingApproval.vue');
const CommsPayoutDetails = () => import(/* webpackChunkName: "tables" */ '@/views/Commission/Hub/HubCommsPayout/CommsPayoutDetails.vue');

//Payout
const PayoutDistribution = () => import(/* webpackChunkName: "tables" */ '@/views/Commission/Payout/PayoutDistribution.vue');

// Recruitment
const RecruitmentListings = () => import(/* webpackChunkName: "tables" */ '@/views/Commission/Recruitment/RecruitmentListings.vue');

const LeadsListings = () => import(/* webpackChunkName: "tables" */ '@/views/Leads/LeadsListing.vue');
const LeadsProfileDetails = () => import(/* webpackChunkName: "tables" */ '@/views/Leads/LeadsProfile/LeadsProfileDetails.vue');
const LeadsCalendar = () => import(/* webpackChunkName: "tables" */ '@/views/Calendar/Calendar.vue');

const MeetingsListings = () => import(/* webpackChunkName: "tables" */ '@/views/Meeting/MeetingListings.vue');

//SETTINGS
const MainStatusSettings = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/MainStatusSettings/MainStatusListing.vue');
const SourceChannelSettings = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/SourceChannelSettings/SourceChannelListing.vue');
const MainCallListings = () => import(/* webpackChunkName: "tables" */ '@/views/Call/CallListing.vue');
const UserManagement = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/UserManagement/UserManagementListing.vue');
const ReviewLink = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/ReviewLink.vue');
// const Email = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/Email.vue');

// @/views/Configurations/SourceChannelSettings/SourceChannelListing.vue

const CustomerStatusSettings = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/CustomerStatusSettings/CustomerStatusListing.vue');
const RoleAccessSettings = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/RoleAccessSettings/RoleAccessListing.vue');
const CommissionSettings = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/CommissionSettings/CommissionListing.vue');
const MortgageStatusSettings = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/MortgageStatusSettings/MortgageStatusListing.vue');
const AdvisoryStatusSettings = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/AdvisoryStatusSettings/AdvisoryStatusListing.vue');
const PersonalLoanStatusSettings = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/PersonalLoanStatusSettings/PersonalLoanStatusListing.vue');
const OtherLoanStatusSettings = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/OtherLoanStatusSettings/OtherLoanStatusListing.vue');
const InsuranceStatusSettings = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/InsuranceStatusSettings/InsuranceStatusListing.vue');
const PreferredBanks = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/PreferredBanks/PreferredBanks.vue');
const InitialProposalSettings = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/InitialProposalSettings/InitialProposalSettings.vue');

const FWDTargetSettings = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/FWDTargetSettings/FWDTargetSettings.vue');
const SmsTemplates = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/SmsTemplates/SmsTemplatesListing.vue');
const EmailAndNotifTemplates = () => import(/* webpackChunkName: "tables" */ '@/views/Configurations/EmailAndNotifTemplates/EmailTemplatesListing.vue');

const CasesListings = () => import(/* webpackChunkName: "tables" */ '@/views/Cases/CasesListings.vue');

//INITIAL PROPOSAL
const InitialProposalListing = () => import(/* webpackChunkName: "tables" */ '@/views/InitialProposal/InitialProposalListing.vue');
const InitialProposalDetails = () => import(/* webpackChunkName: "tables" */ '@/views/InitialProposal/InitialProposalDetails.vue');

// Sales List
const ProFormaInvoicesListings = () => import(/* webpackChunkName: "tables" */ '@/views/Sales/ProFormaInvoices/ProFormaInvoicesListings.vue');
const InvoicesListings = () => import(/* webpackChunkName: "tables" */ '@/views/Sales/Invoices/InvoicesListings.vue');

// Reports
const LeadReport = () => import(/* webpackChunkName: "tables" */ '@/views/Reports/LeadReport.vue');
const LeadAnalysisReport = () => import(/* webpackChunkName: "tables" */ '@/views/Reports/LeadAnalysis.vue');

const CustomerReport = () => import(/* webpackChunkName: "tables" */ '@/views/Reports/CustomerReport.vue');
const CustomerIncomeAnalysisReport = () => import(/* webpackChunkName: "tables" */ '@/views/Reports/CustomerIncomeAnalysisReport.vue');

const CaseReport = () => import(/* webpackChunkName: "tables" */ '@/views/Reports/CaseReport.vue');
const KPIReport = () => import(/* webpackChunkName: "tables" */ '@/views/Reports/KPIReport.vue');
const RevenueReport = () => import(/* webpackChunkName: "tables" */ '@/views/Reports/RevenueReport.vue');
const CommissionReport = () => import(/* webpackChunkName: "tables" */ '@/views/Reports/CommissionReport.vue');
const SalesReport = () => import(/* webpackChunkName: "tables" */ '@/views/Reports/SalesReport.vue');
const MonthlyCommissionReport = () => import(/* webpackChunkName: "tables" */ '@/views/Reports/CommissionReport/MonthlyCommissionReport.vue');
const CompanyRevenue = () => import(/* webpackChunkName: "tables" */ '@/views/Reports/CompanyRevenue/CompanyRevenueSummary.vue');
const RevenuePoint = () => import(/* webpackChunkName: "tables" */ '@/views/Reports/RevenuePoint/RevenuePointSummary.vue');

// Pending Approvals
const PendingApproval = () => import(/* webpackChunkName: "tables" */ '@/views/PendingApprovals/PendingApproval.vue');
const VpsPendingApproval = () => import(/* webpackChunkName: "tables" */ '@/views/PendingApprovals/VPS/VpsPendingApproval.vue');

// Calculators
const Calculators = () => import(/* webpackChunkName: "tables" */ '@/views/Calculators/Calculators.vue');

// CreditReports
const CreditReports = () => import(/* webpackChunkName: "tables" */ '@/views/CreditReports/CreditReports.vue');
const CreditBalance = () => import(/* webpackChunkName: "tables" */ '@/views/CreditReports/CreditBalance/CreditBalanceListings.vue');
const SMEReports = () => import(/* webpackChunkName: "tables" */ '@/views/CreditReports/SMEReports/SMEReportsListings.vue');

// Initial Proposals

// Notifications
const NotificationsView = () => import(/* webpackChunkName: "tables" */ '@/views/Notifications/Notifications.vue');

const PropertyListing = () => import(/* webpackChunkName: "tables" */ '@/views/PropertyListing/PropertyListing.vue');
const BrowseProperty = () => import(/* webpackChunkName: "tables" */ '@/views/PropertyListing/BrowseProperty.vue');

const LeadForm = () => import(/* webpackChunkName: "tables" */ '@/views/Public/LeadForm.vue');
const NewAgentRegistrationForm = () => import(/* webpackChunkName: "tables" */ '@/views/Public/NewAgentRegistrationForm.vue');

const UpgradePage = () => import(/* webpackChunkName: "tables" */ '@/views/Pages/UpgradePage.vue');

const LoanAdvisory = () => import(/* webpackChunkName: "tables" */ '@/views/LoanAdvisory/LoanAdvisoryListings/LoanAdvisory.vue');

let componentsMenu = {
	path: '/components',
	component: DashboardLayout,
	redirect: '/components/buttons',
	name: 'Components',
	children: [
		{
			path: 'buttons',
			name: 'Buttons',
			component: Buttons
		},
		{
			path: 'cards',
			name: 'Cards',
			component: Cards
		},
		{
			path: 'grid-system',
			name: 'Grid System',
			component: GridSystem
		},
		{
			path: 'notifications',
			name: 'Notifications',
			component: Notifications
		},
		{
			path: 'icons',
			name: 'Icons',
			component: Icons
		},
		{
			path: 'typography',
			name: 'Typography',
			component: Typography
		},
		{
			path: 'nested-sorting',
			name: 'Nested Sorting',
			component: NestedSorting
		}
	]
};

let formsMenu = {
	path: '/forms',
	component: DashboardLayout,
	redirect: '/forms/elements',
	name: 'Forms',
	children: [
		{
			path: 'elements',
			name: 'Form elements',
			component: FormElements
		},
		{
			path: 'components',
			name: 'Form components',
			component: FormComponents
		},
		{
			path: 'validation',
			name: 'Form validation',
			component: FormValidation
		}
	]
};

let tablesMenu = {
	path: '/tables',
	component: DashboardLayout,
	redirect: '/table/regular',
	name: 'Tables menu',
	children: [
		{
			path: 'regular',
			name: 'Tables',
			component: RegularTables
		},
		{
			path: 'sortable',
			name: 'Sortable',
			component: SortableTables
		},
		{
			path: 'paginated',
			name: 'Paginated Tables',
			component: PaginatedTables
		}
	]
};

let mapsMenu = {
	path: '/maps',
	component: DashboardLayout,
	name: 'Maps',
	redirect: '/maps/google',
	children: [
		{
			path: 'google',
			name: 'Google Maps',
			component: GoogleMaps
		},
		{
			path: 'vector',
			name: 'Vector Map',
			component: VectorMaps
		}
	]
};

let pagesMenu = {
	path: '/pages',
	component: DashboardLayout,
	name: 'Pages',
	redirect: '/pages/user',
	children: [
		{
			path: 'user',
			name: 'User Page',
			component: User
		},
		{
			path: 'timeline',
			name: 'Timeline Page',
			component: TimeLine
		}
	]
};

let authPages = {
	path: '/',
	component: AuthLayout,
	name: 'Authentication',
	children: [
		{
			path: '/login',
			name: 'Login',
			component: Login
		},
		{
			path: '/register',
			name: 'Register',
			component: Register
		},
		{
			path: '/pricing',
			name: 'Pricing',
			component: Pricing
		},
		{
			path: '/lock',
			name: 'Lock',
			component: Lock
		},
	]
};

let setupMenu = {
	path: '/setup',
	component: DashboardLayout,
	redirect: '/setup/users',
	name: 'Setup menu',
	children: [
		{
			path: 'users',
			name: 'Users',
			meta: { requiresAuth: true },
			component: Users,
		},
		{
			path: 'addUsers',
			name: 'Add Users',
			meta: { requiresAuth: true },
			component: AddUsers,
		},
		{
			path: 'editUsers/:id',
			name: 'Edit Users',
			meta: { requiresAuth: true },
			component: EditUsers,
		},
		{
			path: 'my_profile',
			name: 'My Profile',
			meta: { requiresAuth: true },
			component: MyUserProfile,
		},
		{
			path: 'variable_expense',
			name: 'Variable Expense',
			meta: { requiresAuth: true },
			component: VariableExpense,
		},
		{
			path: 'addVariableExpense',
			name: 'Add Variable Expense',
			meta: { requiresAuth: true },
			component: AddVariableExpense,
		},
		{
			path: 'editVariableExpense/:id',
			name: 'Edit Variable Expense',
			meta: { requiresAuth: true },
			component: EditVariableExpense,
		},
	]
};

let customerMenu = {
	path: '/customer',
	redirect: '/customerProfile',
	component: DashboardLayout,
	name: 'Customer',
	children: [
		{
			path: '/customerProfile',
			name: 'Customer Profile',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['c_customer__listing'],
				requiresRoleAccess: { module_code: 'c_customer', access_column: 'access_listing' }
			},
			component: CustomerProfile,
		},
		{
			path: '/customerProfileDetails/:customer_id',
			name: 'Customer Profile Details',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['c_customer__show'],
				requiresRoleAccess: { module_code: 'c_customer', access_column: 'access_show' }
			},
			component: CustomerProfileDetails,
		},
	]
}

let casesMenu = {
	path: '/cases',
	component: DashboardLayout,
	name: 'Cases Menu',
	children: [
		{
			path: '/casesListings',
			name: 'Cases Listing',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['p_product__listing'],
				requiresRoleAccess: { module_code: 'p_product', access_column: 'access_listing' }
			},
			component: CasesListings,
		},
	]
}

let initialProposalMenu = {
  path: '/initialProposal',
  component: DashboardLayout,
  name: 'Initial Proposal Menu',
  children: [
    {
      path: '/initialProposal',
      name: 'Initial Proposal Listing',
      meta : { 
        requiresAuth: true, 
        requiresAppCode: ['sas']
      },
      component: InitialProposalListing,
    },
		{
			path: '/initialProposalDetails/:psal_id',
			name: 'Initial Proposal Details',
			meta: {
				requiresAuth: true,
				requiresAppCode: ['sas']
			},
			component: InitialProposalDetails,
		},
  ]
}


let salesMenu = {
	path: '/sales',
	component: DashboardLayout,
	name: 'Sales Menu',
	children: [
		{
			path: '/proFormaInvoices',
			name: 'ProForma Invoices Listing',
			meta: { requiresAuth: true },
			component: ProFormaInvoicesListings,
		},
		{
			path: '/invoices',
			name: 'Invoices Listing',
			meta: { requiresAuth: true },
			component: InvoicesListings,
		},
	]
}

let hubMenu = {
	path: '/hub',
	component: DashboardLayout,
	name: 'Hub',
	meta: {
		requiresAccessCodes: ['h_hub__create'],
		requiresRoleAccess: { module_code: 'h_hub', access_column: 'access_create' }
	},
	children: [
		{
			path: '/hubListings',
			name: 'Hub Listing',
			meta: { requiresAuth: true },
			component: HubListings,
		},
		{
			path: '/editHubDetails/:id',
			name: 'Edit Hub Details',
			meta: { requiresAuth: true },
			component: EditHubDetails,
		},
		{
			path: '/hubProfile',
			name: 'Hub Profile',
			meta: { requiresAuth: true },
			component: HubProfile,
		},
		{
			path: '/hubProfileDetails/:hub_id',
			name: 'Hub Profile Details',
			meta: { requiresAuth: true },
			component: HubProfileDetails,
		},
		{
			path: '/teamProfileDetails/:hub_team_id',
			name: 'Team Profile Details',
			meta: { requiresAuth: true },
			component: TeamProfileDetails,
		},
		{
			path: '/hubApproval',
			name: 'Hub Approval',
			meta: { requiresAuth: true },
			component: HubPendingApproval,
		},
		{
			path: '/commsPayoutDetails/:comms_payout_summary_id',
			name: 'Commission Payout Summary Details',
			meta: { requiresAuth: true },
			component: CommsPayoutDetails,
		},
	]
}

let payoutMenu = {
	path: '/payout',
	component: DashboardLayout,
	name: 'Payout',
	children: [
		{
			path: '/payoutDistribution',
			name: 'Payout Distribution',
			meta: { requiresAuth: true },
			component: PayoutDistribution,
		},
	]
}

let recruitmentMenu = {
	path: '/recruitment',
	component: DashboardLayout,
	name: 'Recruitment',
	children: [
		{
			path: '/recruitmentListings',
			name: 'Recruitment Listings',
			meta: { requiresAuth: true },
			component: RecruitmentListings,
		},
	]
}

let MeetingMenu = {
	path: '/meetings',
	component: DashboardLayout,
	name: 'Meetings',
	children: [
		{
			path: '/meetingsListings',
			name: 'Meetings Listings',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['l_lead__create'],
				requiresRoleAccess: { module_code: 'l_lead', access_column: 'access_create' }
			},
			component: MeetingsListings,
		},
	]
}

let leadsMenu = {
	path: '/leads',
	component: DashboardLayout,
	name: 'Leads',
	children: [
		{
			path: '/leadsListings',
			name: 'Leads Listing',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['l_lead__listing'],
				requiresRoleAccess: { module_code: 'l_lead', access_column: 'access_listing' }
			},
			component: LeadsListings,
		},
		{
			path: '/leadProfileDetails/:lead_id',
			name: 'Leads Profile Details',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['l_lead__show'],
				requiresRoleAccess: { module_code: 'l_lead', access_column: 'access_show' }
			},
			component: LeadsProfileDetails,
		},
		{
			path: '/leadsCalendar',
			name: 'Leads Calendar',
			// meta: {
			// 	requiresAuth: true,
			// 	requiresAccessCodes: ['l_lead__listing'],
			// 	requiresRoleAccess: { module_code: 'l_lead', access_column: 'access_listing' }
			// },
			component: LeadsCalendar,
		},
		{
            path: '/customersCalendar',
            name: 'Customers Calendar',
            component: CustomersCalendar,
      },
      {
            path: '/casesCalendar',
            name: 'Cases Calendar',
            component: CasesCalendar,
      }
	]
}

let settingsMenu = {
	path: '/settings',
	component: DashboardLayout,
	name: 'Settings',
	children: [
		{
			path: 'leadStatus',
			name: 'Lead Status',
			meta: {
				requiresAuth: true,
				requiresRoleType: ['admin', 'corporate', 'manager'],
				requiresOrAccessCodes: ['stg_lead_status'],
				requiresOrRoleAccess: { module_code: 'stg_lead_status', access_column: 'access_listing' }
			},
			component: MainStatusSettings,
		},
		{
			path: '/userManagement',
			name: 'User Management',
			meta: {
				requiresAuth: true,
				requiresRoleType: ['admin', 'corporate', 'manager'],
				requiresOrAccessCodes: ['stg_user_management'],
				requiresOrRoleAccess: { module_code: 'stg_user_management', access_column: 'access_listing' }
			},
			component: UserManagement,
		},
        {
            path: '/reviewLink',
            name: 'Review Link',
            meta: {
                requiresAuth: true,
                requiresRoleType: ['admin', 'corporate', 'manager'],
                requiresOrAccessCodes: ['stg_review_link'],
                requiresOrRoleAccess: { module_code: 'stg_review_link', access_column: 'access_listing' }
            },
            component: ReviewLink,
        },
        {
          path: 'advisoryStatus',
          name: 'Advisory Status',
          meta: {
              requiresAuth: true,
              requiresRoleType: ['admin', 'corporate', 'manager'],
              requiresOrAccessCodes: ['stg_advisory_status'],
              requiresOrRoleAccess: { module_code: 'stg_advisory_status', access_column: 'access_listing' }
          },
          component: AdvisoryStatusSettings,
      },
    //   {
    //     path: '/email',
    //     name: 'Email',
    //     meta: {
    //         requiresAuth: true,
    //         requiresRoleType: ['admin', 'corporate', 'manager'],
    //         requiresOrAccessCodes: ['stg_email'],
    //         requiresOrRoleAccess: { module_code: 'stg_email', access_column: 'access_listing' }
    //     },
    //     component: Email,
    // },
		{
			path: 'roleAccess',
			name: 'Role Access',
			meta: {
				requiresAuth: true,
				requiresRoleType: ['admin', 'corporate'],
				requiresOrAccessCodes: ['stg_role_access'],
				requiresOrRoleAccess: { module_code: 'stg_role_access', access_column: 'access_listing' }
			},
			component: RoleAccessSettings,
		},
		{
			path: 'commission',
			name: 'Commission',
			meta: {
				requiresAuth: true,
				requiresRoleType: ['admin', 'corporate'],
				requiresOrAccessCodes: ['stg_role_access'],
				requiresOrRoleAccess: { module_code: 'stg_role_access', access_column: 'access_listing' }
			},
			component: CommissionSettings,
		},
		{
			path: 'customerStatus',
			meta: {
				requiresAuth: true,
				requiresRoleType: ['admin', 'corporate', 'manager'],
				requiresOrAccessCodes: ['stg_customer_status'],
				requiresOrRoleAccess: { module_code: 'stg_customer_status', access_column: 'access_listing' }
			},
			component: CustomerStatusSettings,
		},
		{
			path: 'channelSetting',
			name: 'Source Channel',
			meta: {
				requiresAuth: true,
				requiresRoleType: ['corporate', 'admin', 'director'],
				requiresAppCode: ['sas'],
				requiresOrAccessCodes: ['stg_channel_platform'],
				requiresOrRoleAccess: { module_code: 'stg_channel_platform', access_column: 'access_listing' }
			},
			component: SourceChannelSettings,
		},
		{
			path: 'mortgageStatus',
			name: 'Mortgage Status',
			meta: {
				requiresAuth: true,
				requiresRoleType: ['corporate', 'admin', 'director'],
				requiresAppCode: ['sas'],
				requiresOrAccessCodes: ['stg_mortgage_status'],
				requiresOrRoleAccess: { module_code: 'stg_mortgage_status', access_column: 'access_listing' }
			},
			component: MortgageStatusSettings,
		},
		{
			path: 'personalLoanStatus',
			name: 'Personal Loan Status',
			meta: {
				requiresAuth: true,
				requiresRoleType: ['corporate', 'admin', 'director'],
				requiresAppCode: ['sas'],
				requiresOrAccessCodes: ['stg_personal_loan_status'],
				requiresOrRoleAccess: { module_code: 'stg_personal_loan_status', access_column: 'access_listing' }
			},
			component: PersonalLoanStatusSettings,
			component: PersonalLoanStatusSettings,
		},
		{
			path: 'insuranceStatus',
			name: 'Insurance Status',
			meta: {
				requiresAuth: true,
				requiresRoleType: ['corporate', 'admin', 'director'],
				requiresAppCode: ['sas'],
				requiresOrAccessCodes: ['stg_insurance_status'],
				requiresOrRoleAccess: { module_code: 'stg_insurance_status', access_column: 'access_listing' }
			},
			component: InsuranceStatusSettings,
		},
		{
			path: 'otherLoanStatus',
			name: 'Other Loan Status',
			meta: { 
			  requiresAuth: true, 
			  requiresRoleType: ['corporate', 'admin', 'director'],
			  requiresAppCode: ['sas'],
			  requiresOrAccessCodes: ['stg_other_loan_status'],
			  requiresOrRoleAccess: { module_code: 'stg_other_loan_status', access_column: 'access_listing' }
			},
			component: OtherLoanStatusSettings,
		},
		{
			path: 'preferredBanks',
			name: 'Preferred Banks',
			meta: {
				requiresAuth: true,
				requiresSubscriptionOwner: true,
			},
			component: PreferredBanks,
		},
		{
			path: 'fwd-target',
			name: 'FWD Target',
			meta: {
				requiresAuth: true,
				requiresRoleType: ['admin', 'corporate', 'manager'],
				requiresAppCode: ['sas'],
				requiresAccessCodes: ['role_admin', 'role_corporate', 'role_super_admin']
			},
			component: FWDTargetSettings,
		},
		{
			path: 'fees-charges',
			name: 'Fees & Charges',
			meta: {
				requiresAuth: true,
				requiresRoleType: ['admin', 'corporate', 'manager'],
				requiresAppCode: ['sas'],
				requiresAccessCodes: ['role_admin', 'role_corporate', 'role_super_admin']
			},
			component: InitialProposalSettings,
		},
		{
			path: 'sms-templates',
			name: 'SMS Templates',
			meta: {
				requiresAuth: true,
				requiresRoleType: ['admin', 'corporate', 'manager'],
				requiresAppCode: ['sas'],
				requiresAccessCodes: ['role_admin', 'role_corporate', 'role_super_admin']
			},
			component: SmsTemplates,
		},
		{
			path: 'email-templates',
			name: 'Email Templates',
			meta: {
				requiresAuth: true,
				requiresRoleType: ['admin', 'corporate', 'manager'],
				requiresAppCode: ['sas'],
				requiresAccessCodes: ['role_admin', 'role_corporate', 'role_super_admin']
			},
			component: EmailAndNotifTemplates,
		}
	]
}

let callListing = {
	path: '/call',
	component: DashboardLayout,
	name: 'Calls',
	children: [
		{
			path: '/callsListings',
			name: 'Main Call',
			meta: { requiresAuth: true },
			component: MainCallListings,
		}
	]
}

let reportMenu = {
	path: '/reports',
	component: DashboardLayout,
	name: 'Report',
	children: [
		{
			path: 'lead',
			name: 'Lead Report',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['l_report__listing'],
				requiresRoleAccess: { module_code: 'l_report', access_column: 'access_listing' }
			},
			component: LeadReport,
		},
		{
			path: 'lead-analysis',
			name: 'Marketing Lead Analysis Report',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['r__marketing_lead_analysis__listing'],
				requiresRoleAccess: { module_code: 'l_report', access_column: 'access_listing' }
			},
			component: LeadAnalysisReport,
		},
		{
			path: 'customer',
			name: 'Customer Report',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['c_report__listing'],
				requiresRoleAccess: { module_code: 'c_report', access_column: 'access_listing' }
			},
			component: CustomerReport,
		},
		{
			path: 'customer-income-analysis',
			name: 'Customer Income Analysis Report',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['r__customer_income_analysis'],
				requiresRoleAccess: { module_code: 'c_report', access_column: 'access_listing' }
			},
			component: CustomerIncomeAnalysisReport,
		},
		{
			path: 'case',
			name: 'Case Report',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['c_report__listing'],
				requiresRoleAccess: { module_code: 'c_report', access_column: 'access_listing' }
			},
			component: CaseReport,
		},
		{
			path: 'revenue',
			name: 'Revenue Report',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['revenue_report'],
			},
			component: RevenueReport,
		},
		{
			path: 'commission',
			name: 'Commission Report',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['commission_report'],
			},
			component: CommissionReport,
		},
		{
			path: 'sales',
			name: 'Sales Report',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['sales_report'],
			},
			component: SalesReport,
		},
		{
			path: 'kpi',
			name: 'KPI Report',
			meta : { 
				requiresAuth: true,
				requiresAppCode: ['sas','vps'],
				requiresAccessCodes: ['c_report__listing'],
				requiresRoleAccess: { module_code: 'c_report', access_column: 'access_listing' }
			},
			component: KPIReport,
		  },
		{
			path: 'monthlyCommission',
			name: 'Monthly Commission Report',
			meta: {
				requiresAuth: true,
				requiresAppCode: ['sas'],
				requiresAccessCodes: ['r_report__listing'],
				requiresRoleAccess: { module_code: 'r_report', access_column: 'access_listing' }
			},
			component: MonthlyCommissionReport,
		},
		{
			path: 'companyRevenue',
			name: 'Company Revenue Summary',
			meta: {
				requiresAuth: true,
				requiresAppCode: ['sas'],
				requiresAccessCodes: ['r_report__listing'],
				requiresRoleAccess: { module_code: 'r_report', access_column: 'access_listing' }
			},
			component: CompanyRevenue,
		},
		{
			path: 'revenuePoint',
			name: 'Revenue Point Summary',
			meta: {
				requiresAuth: true,
				requiresAppCode: ['sas'],
				requiresAccessCodes: ['r_report__listing'],
				requiresRoleAccess: { module_code: 'r_report', access_column: 'access_listing' }
			},
			component: RevenuePoint,
		},
	]
}

let pendingApprovalMenu = {
	path: '/pendingApprovals',
	component: DashboardLayout,
	children: [
		{
			path: '/pendingApprovals',
			name: 'Pending Approval',
			meta: {
				requiresAuth: true,
				requiresAppCode: ['sas'],
				requiresAccessCodes: ['a_approval__listing'],
				requiresRoleAccess: { module_code: 'a_approval', access_column: 'access_listing' },
			},
			component: PendingApproval,
		},
		{
			path: '/vps-pendingApprovals',
			name: 'VPS Pending Approval',
			meta: {
				requiresAuth: true,
				requiresAppCode: ['vps', 'dahongye'],
				requiresAccessCodes: ['vps_approval__listing'],
				requiresRoleAccess: { module_code: 'a_approval', access_column: 'access_listing' },
			},
			component: VpsPendingApproval,
		},
	]
}

let calculatorsMenu = {
	path: '/calculators',
	component: DashboardLayout,
	children: [
		{
			path: '',
			name: 'Calculators',
			meta: { requiresAuth: true, },
			component: Calculators,
		},
	]
}

let creditReportsMenu = {
	path: '/credit-reports',
	component: DashboardLayout,
	children: [
		{
			path: '/purchased-reports',
			name: 'CreditReports',
			meta: { 
				requiresAuth: true
			},
			component: CreditReports,
		},
		{
			path: '/credit-balance',
			name: 'Credit Balance',
			meta: { 
				requiresAuth: true 
			},
			component: CreditBalance,
		},
		{
			path: '/sme-reports',
			name: 'SMEReports',
			meta: { 
				requiresAuth: true 
			},
			component: SMEReports,
		},
	]
}

let propertyListingMenu = {
	path: '/propertyListing',
	component: PropertyListingLayout,
	children: [
		{
			path: '/',
			meta: { requiresAuth: true, requiresSubcription: 'scpk_la_property' },
			component: PropertyListing,
		},
		{
			path: ':project_id',
			meta: { requiresAuth: true, requiresSubcription: 'scpk_la_property' },
			component: BrowseProperty,
		},
	]
}

let loanAdvisoryMenu = {
	path: '/loanAdvisory',
	redirect: '/loanAdvisoryListing',
	component: DashboardLayout,
	name: 'Loan Advisory',
	children: [
		{
			path: '/loanAdvisoryListing',
			name: 'Loan Advisory Listing',
			meta: {
				requiresAuth: true,
				requiresAccessCodes: ['c_customer__listing'],
				requiresRoleAccess: { module_code: 'c_customer', access_column: 'access_listing' }
			},
			component: LoanAdvisory,
		},
	]
}
const routes = [
	{
		path: '/messaging',
		name: 'Messaging',
		meta: { 
			publicAuth: true 
		},
		component: Messaging
	},
	{
		path: '/',
		component: DashboardLayout,
		children: [
			{
				name: 'Home',
				path: '/',
				meta: { requiresAuth: true, },
				component: Home,
			},
		]
	},
	authPages,
	{
		path: '/upgrade',
		component: UpgradePage,
		name: 'updgrade',
		meta: {
			requiresAuth: true
		}
	},
	// componentsMenu,
	// formsMenu,
	// tablesMenu,
	// mapsMenu,
	// pagesMenu,
	setupMenu,
	// proposalMenu,
	casesMenu,
	initialProposalMenu,
	salesMenu,
	customerMenu,
	hubMenu,
	payoutMenu,
	recruitmentMenu,
	leadsMenu,
	settingsMenu,
	MeetingMenu,
	callListing,
	reportMenu,
	pendingApprovalMenu,
	calculatorsMenu,
	creditReportsMenu,
	propertyListingMenu,
	loanAdvisoryMenu,
	{
		path: '/public/leadForm',
		component: LeadForm,
	},
	{
		path: '/new-agent-registration/:public_code',
		component: NewAgentRegistrationForm,
	},
	{
		path: '/subscription-ended',
		name: 'SubscriptionEnded',
		component: SubscriptionEnded,
	},
	{
		path: '/invalid-account',
		name: 'InvalidAccount',
		component: InvalidAccount,
	},
	{
		path: '/notifications',
		name: 'notifications',
		component: NotificationsView
	},
	// {
	// 	path: '/',
	// 	component: DashboardLayout,
	// 	redirect: '/dashboard',
	// 	name: 'Dashboard layout',
	// 	children: [
	// 		{
	// 			path: 'dashboard',
	// 			name: 'Dashboard',
	// 			component: Dashboard
	// 		},
	// 		{
	// 			path: 'alternative',
	// 			name: 'Alternative',
	// 			component: AlternativeDashboard,
	// 			meta: {
	// 				navbarType: 'light'
	// 			}
	// 		},
	// 		{
	// 			path: 'calendar',
	// 			name: 'Calendar',
	// 			component: Calendar
	// 		},
	// 		{
	// 			path: 'charts',
	// 			name: 'Charts',
	// 			component: Charts
	// 		},
	// 		{
	// 			path: 'widgets',
	// 			name: 'Widgets',
	// 			component: Widgets
	// 		},
	// 	]
	// },
	{ path: '*', component: NotFound, name: 'NotFound' },
	
];

export default routes;
